import React, { useState, useContext, useEffect } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../utils/toast";
import ButtonUI from "../../material-ui/ButtonUI";
import { ApproveActionButton } from "../../common/ActionIconButton";
import { AuthContext } from "../../../context/Auth/AuthContext";
import approveRequestedCase from "../../../api/approveRequestedCase";

/*** Component for approving the document from the Requested section ***/
const ApproveCasePopup = ({ tableValues, setCategoryUpdatedToTrue }) => {
  const [open, setOpen] = useState(false);
  const [approveLoading, setApproveLoading] = useState(false);
  const { token } = useContext(AuthContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onApproveDocumentFormSubmit = async () => {
    setApproveLoading(true);
    const payload = {
      token: token,
      doc_id: tableValues.doc_id,
      doc_req_id: tableValues.document_request_id,
    };

    try {
      const approveCaseFormResponse = await approveRequestedCase(payload);

      if (approveCaseFormResponse?.code === 200) {
        setOpen(false);
        setCategoryUpdatedToTrue();
        showSuccess("Document is approved successfully");
      } else {
        showError("Error while approving document");
      }
    } catch (error) {
      console.error(error);
      showError("Something went wrong");
    } finally {
      setApproveLoading(false); // always stop loading
    }
  };
  const canApproveNow =
    tableValues.document_status?.toLowerCase() === "uploaded";

  return (
    <div className="dialog-modal">
      <ApproveActionButton
        onClick={handleClickOpen}
        disabled={!canApproveNow}
        disabledReason="Only uploaded documents can be approved"
      />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <CheckCircleIcon />
          </div>
          <div className="popup-header-title">Approve Document</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to approve this document ?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{
              margin: "15px 0px",
              marginTop: "0px",
              backgroundColor: "#fff",
              color: "#1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            loading={approveLoading}
            disabled={approveLoading}
            style={{
              margin: "15px",
              marginTop: "0px",
              backgroundColor: "#fff",
              color: "##1a6b7c",
              border: "1px solid #1a6b7c",
            }}
            autoFocus={true}
            onClickFunc={() => {
              onApproveDocumentFormSubmit();
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ApproveCasePopup;
